/** Comparable reference shared by ValidationResult and ExternalValidationResult. */
interface ComparableRuleRef {
  propertyId?: string;
  comparableNumber?: number | null;
}

/** Resolves a rule's comparable id: explicit propertyId, else comparableNumber mapped through the comp order. */
export function resolveRuleComparableId(rule: ComparableRuleRef, comparableIdOrder: string[]): string | undefined {
  if (rule.propertyId) return rule.propertyId;
  if ((rule.comparableNumber ?? 0) > 0) return comparableIdOrder[(rule.comparableNumber as number) - 1];
  return undefined;
}

/** Whether a COMPARABLE rule applies to the comp cell `propertyId`. A rule with no comparable reference matches all comps. */
export function ruleMatchesComparable(
  rule: ComparableRuleRef,
  propertyId: string | undefined,
  comparableIdOrder: string[]
): boolean {
  if (!rule.propertyId && (rule.comparableNumber ?? 0) <= 0) return true;
  return resolveRuleComparableId(rule, comparableIdOrder) === propertyId;
}
